import AmsterdamHotel1 from '../Assets/Images/amsterdam-hotel1.jpg';
import AmsterdamHotel2 from '../Assets/Images/amsterdam-hotel2.jpg';
import AmsterdamHotel3 from '../Assets/Images/amsterdam-hotel3.jpg';
import AmsterdamHotel4 from '../Assets/Images/amsterdam-hotel4.jpg';
import AmsterdamHotel5 from '../Assets/Images/amsterdam-hotel5.jpg';
import AmsterdamHotel6 from '../Assets/Images/amsterdam-hotel6.jpg';

let AmsterdamCityBreaksItems = [
    {
        id: 1,
        itemImage: AmsterdamHotel1,
        itemTitle: 'Canal View Boutique Stay',
        itemSubTitle: 'Amsterdam, Netherlands',
        itemNights: '2 nights',
        itemPrice: '£499'
    },
    {
        id: 2,
        itemImage: AmsterdamHotel2,
        itemTitle: 'Modern Central Apartment Hotel',
        itemSubTitle: 'Amsterdam, Netherlands',
        itemNights: '3 nights',
        itemPrice: '£599'
    },
    {
        id: 3,
        itemImage: AmsterdamHotel3,
        itemTitle: 'Historic Townhouse Hotel',
        itemSubTitle: 'Amsterdam, Netherlands',
        itemNights: '3 nights',
        itemPrice: '£799'
    },
    {
        id: 4,
        itemImage: AmsterdamHotel4,
        itemTitle: 'Minimalist Riverside Stay',
        itemSubTitle: 'Amsterdam, Netherlands',
        itemNights: '3 nights',
        itemPrice: '£399'
    },
    {
        id: 5,
        itemImage: AmsterdamHotel5,
        itemTitle: 'Vintage Canal House Hotel',
        itemSubTitle: 'Amsterdam, Netherlands',
        itemNights: '2 nights',
        itemPrice: '£499'
    },
    {
        id: 6,
        itemImage: AmsterdamHotel6,
        itemTitle: 'Creative District Stay',
        itemSubTitle: 'Amsterdam, Netherlands',
        itemNights: '3 nights',
        itemPrice: '£299'
    }
];

export default AmsterdamCityBreaksItems;
